module.exports = __webpack_public_path__ + "static/media/mirror.b7561575.svg";